import styled from 'styled-components';
import { Container } from '../../styles/sharedComponents';

export const CodeShowcaseSection = styled.section<{ $isVisible?: boolean }>`
  padding: 120px 0;
  background: #0a0a0a;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 250px;
    background: linear-gradient(180deg,
      transparent 0%,
      rgba(255, 68, 68, 0.005) 15%,
      rgba(255, 68, 68, 0.01) 40%,
      rgba(255, 68, 68, 0.015) 70%,
      rgba(255, 68, 68, 0.02) 100%
    );
    pointer-events: none;
    z-index: 1;
  }
`;

export const CodeShowcaseContent = styled(Container)`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 80px;
  align-items: center;

  @media (max-width: 968px) {
    grid-template-columns: 1fr;
    gap: 60px;
    text-align: center;
  }
`;

export const CodeShowcaseText = styled.div`
  h2 {
    font-size: clamp(32px, 5vw, 48px);
    font-weight: 700;
    color: #fafafa;
    margin-bottom: 24px;
    line-height: 1.2;
    background: linear-gradient(180deg, #fafafa 0%, #a1a1aa 100%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  p {
    font-size: 1.125rem;
    color: #a0a0a0;
    line-height: 1.7;
    margin-bottom: 32px;
  }
`;

export const DashboardMockup = styled.div`
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 16px;
  overflow: hidden;
  position: relative;
  backdrop-filter: blur(16px);
  max-width: 500px;
  width: 100%;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(45deg, rgba(255, 68, 68, 0.05), rgba(68, 255, 68, 0.05));
    opacity: 0;
    transition: opacity 0.3s ease;
  }

  &:hover::before {
    opacity: 1;
  }
`;

export const MockupHeader = styled.div`
  display: flex;
  align-items: center;
  padding: 16px 20px;
  background: rgba(255, 255, 255, 0.05);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);

  .dots {
    display: flex;
    gap: 6px;
    margin-right: 16px;

    span {
      width: 10px;
      height: 10px;
      border-radius: 50%;

      &:nth-child(1) { background: #ff5f57; }
      &:nth-child(2) { background: #ffbd2e; }
      &:nth-child(3) { background: #28ca42; }
    }
  }

  .title {
    color: #e0e0e0;
    font-size: 13px;
    font-weight: 500;
  }
`;

export const MockupContent = styled.div`
  padding: 24px;
`;

export const MockupStatsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-bottom: 24px;
`;

export const MockupCard = styled.div`
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 8px;
  padding: 16px;
  display: flex;
  align-items: center;
  gap: 12px;
  transition: all 0.3s ease;
  cursor: pointer;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(255, 68, 68, 0.15);
    border-color: rgba(255, 68, 68, 0.3);
  }
`;

export const MockupCardIcon = styled.div`
  width: 36px;
  height: 36px;
  background: rgba(255, 68, 68, 0.1);
  border: 1px solid rgba(255, 68, 68, 0.2);
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const MockupCardInfo = styled.div`
  flex: 1;
`;

export const MockupCardValue = styled.div`
  color: #ffffff;
  font-size: 18px;
  font-weight: 700;
  line-height: 1;
  margin-bottom: 2px;
`;

export const MockupCardLabel = styled.div`
  color: #888888;
  font-size: 10px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 2px;
`;

export const MockupCardChange = styled.div`
  color: #22c55e;
  font-size: 10px;
  font-weight: 600;
`;

export const MockupChart = styled.div`
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  padding: 16px;
`;

export const MockupChartHeader = styled.div`
  color: #ffffff;
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 16px;
`;

export const MockupChartBars = styled.div`
  display: flex;
  align-items: end;
  gap: 4px;
  height: 60px;
`;

export const MockupBar = styled.div<{ height: string }>`
  flex: 1;
  background: linear-gradient(to top, #ff4444, #ff6666);
  border-radius: 2px 2px 0 0;
  height: ${props => props.height};
  opacity: 0.8;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 1;
  }
`;
